/**
 * @fileoverview Model for the number of GBP locations for a given GBP group.
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */


export class GetGbpGroupLocationsResponse {
  /**
   * @param {{
   *  gbpAccountToLocationCount: !Map<string, number>,
   * }} params
   */
  constructor(params) {
    /** @type {!Map<string, number>} */
    this.gbpAccountToLocationCount = params.gbpAccountToLocationCount;
  }

  /**
   * @param {!GetGbpGroupLocationsResponseJson} json
   * @return {!GetGbpGroupLocationsResponse}
   */
  static fromJSON(json) {
    const gbpAccountToLocationCount = new Map(Object.entries(json['gbpAccountToLocationCount']));
    return new GetGbpGroupLocationsResponse({
      gbpAccountToLocationCount,
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  groups: !Map<string, number>,
 * }}
 */
export let GetGbpGroupLocationsResponseJson;
